module.exports = __webpack_public_path__ + "static/media/dataPic.073257fd.svg";